/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Statuscompleted1Inputs */

const zh_learn_statuscompleted1 = /** @type {(inputs: Learn_Statuscompleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已完成`)
};

const en_learn_statuscompleted1 = /** @type {(inputs: Learn_Statuscompleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

const es_learn_statuscompleted1 = /** @type {(inputs: Learn_Statuscompleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completado`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Learn_Statuscompleted1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_statuscompleted1 = /** @type {((inputs?: Learn_Statuscompleted1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Statuscompleted1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_statuscompleted1(inputs)
	if (locale === "en") return en_learn_statuscompleted1(inputs)
	return es_learn_statuscompleted1(inputs)
});
export { learn_statuscompleted1 as "learn_statusCompleted" }